<template>
  <div>

    <!-- Filtering controls -->
    <div v-if="enableSearch" class="filter-container pa-4">
      <div class="d-flex">
        <v-text-field
          v-model="filterValue"
          label="Search"
          class="mr-3"
          @keyup.enter="applyFilter"
          type="text"
          clearable
          append-icon="mdi-magnify"
          @click:append="applyFilter"
        ></v-text-field>
        <v-select
          v-model="filterField"
          :items="searchFields"
          label="Field"
          class="filter-field-select"
        >
          <template v-slot:selection="{ item }">
            <div class="d-flex align-center" style="width: 100%">
              <span>{{ item.text }}</span>
              <v-spacer/>
              <span v-if="item.exact" class="grey--text text-caption">(exact)</span>
            </div>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <span>{{ item.text }}</span>
                <v-spacer/>
                <span v-if="item.exact" class="grey--text text-caption ml-2">(exact search)</span>
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
      </div>
      <div class="d-flex justify-end mt-2">
        <v-btn
          small
          color="primary"
          class="mr-2"
          @click="applyFilter"
        >
          <v-icon left>mdi-magnify</v-icon>
          Search
        </v-btn>
        <v-btn
          small
          color="error"
          :disabled="!isFilterApplied"
          @click="clearFilter"
        >
          <v-icon left>mdi-close</v-icon>
          Clear
        </v-btn>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="objectsArr"
      :hide-default-footer="!!$route.name.match('versions')"
      :hide-default-header="!!$route.name.match('versions')"
      :server-items-length="objectsTotalItems"
      :options.sync="paginationOptions"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 20, 25, 50, 100, 200],
        'items-per-page-text': 'Rows per page:',
        'show-current-page': true
      }"
      @update:options="handlePaginationChange"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title v-if="computedTitle">{{ computedTitle }}</v-toolbar-title>
          <v-divider
            v-if="computedTitle"
            class="mx-4"
            inset
            vertical
          />
          <v-spacer/>
          <v-spacer/>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on" v-if="showNewItemBtn && endpoint !== 'api/end_customers'">New Item</v-btn>
            </template>

            <v-card>
              <!-- EDIT FORM -->
              <v-card-text v-if="objectIsEdit">
                <v-card-title>
                  <span v-if="isEditFieldShouldSetOnlyPassword()" class="headline">Set password</span>
                  <span v-else class="headline">Edit</span>
                </v-card-title>
                <v-container>
                  <v-form v-model="isValidEditForm" ref="editForm" lazy-validation>
                    <v-row>
                    <v-col cols="12" v-for="(ei_value, ei_key) in editedItem" v-bind:key="ei_key" v-if="canEdit(ei_key)">
                      <v-text-field v-if="entity[ei_key].type === 'string' && ei_key !== 'password' && !isEditFieldShouldSetOnlyPassword()"
                                    v-model="editedItem[ei_key]"
                                    :label="`${ei_key}`"
                      />
                      <v-text-field v-if="entity[ei_key].type === 'string' &&  ei_key === 'password'"
                                    v-model="computedObjectInput[ei_key]"
                                    :label="ei_key"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    @click:append="showPassword = !showPassword"
                      />
                      <v-checkbox v-if="entity[ei_key].type === 'boolean'" v-model="editedItem[ei_key]" :label="`${ei_key}`"/>
                      <div v-if="entity[ei_key].type === 'array'">
                        <v-checkbox v-for="(entity_itms_val, entity_itms_key) in entity[ei_key].allItems" v-model="editedItem[ei_key]" :label="entity_itms_val" :value="entity_itms_val" v-bind:key="entity_itms_key" />
                      </div>
                      <div v-if="entity[ei_key].type === 'file'">
                        <v-file-input
                          ref="editFormUploadFile"
                          accept="image/png, image/jpeg"
                          :label="`${ei_key}`"
                          placeholder="Upload file"
                          @change="changedFileUploadOnEditedItem($event, ei_key)"
                          prepend-icon=""
                        ></v-file-input>
                        <div v-if="editedItem[ei_key]">
                          {{ ei_key }} preview
                          <ImageComponent v-if="editedItem[ei_key]" :iri="editedItem[ei_key]" />
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <div v-if="endpoint === 'api/customers'">
                    <v-row >
                      <div class="col-12">
                        mail footer note
                        <v-container fluid class="px-0">
                          <v-textarea
                            rows="3"
                            label="You can use HTML tags"
                            v-model="editedItem['mailFooterNote']"
                          />
                        </v-container>
                      </div>
                    </v-row>
                    <v-row>
                      <div class="col-12">
                        notification mail addresse
                        <v-container fluid class="px-0">
                          <v-text-field
                            label="Email"
                            v-model="editedItem['notificationMail']"
                          />
                        </v-container>
                      </div>
                    </v-row>
                    <v-row>
                      <div class="col-12">
                        BCC notification mail addresses
                        <v-container fluid class="px-0">
                          <v-textarea
                            rows="1"
                            label="Emails list (use , as separator)"
                            v-model="editedItem['bccNotificationMail']"
                          />
                        </v-container>
                      </div>
                    </v-row>
                  </div>
                  </v-form>
                </v-container>
              </v-card-text>
              <!-- CREATE FORM -->
              <v-card-text v-else>
                <v-card-title>
                  <span class="headline">Add new item</span>
                </v-card-title>
                <v-container>
                  <v-form v-model="isValidCreateForm" ref="createForm" lazy-validation>
                    <v-row>
                    <v-col cols="12" v-for="(eaf_value, eaf_key) in editAllowedFields" v-bind:key="eaf_key" v-if="canEdit(eaf_value)">
                      <v-text-field v-if="entity[eaf_value].type === 'string' && eaf_value !== 'password'"
                                    v-model="computedObjectInput[eaf_value]"
                                    :label="eaf_value">
                        <template v-slot:append>
                          <v-tooltip bottom v-if="endpoint === 'api/apps' && eaf_value === 'code'">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <span>Input options available: {{ getAvailableAppCodes }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                      <v-text-field v-if="entity[eaf_value].type === 'string' &&  eaf_value === 'password'"
                                    v-model="computedObjectInput[eaf_value]"
                                    :label="eaf_value"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    @click:append="showPassword = !showPassword"
                      />
                      <v-checkbox v-if="entity[eaf_value].type === 'boolean'"
                                  v-model="computedObjectInput[eaf_value]"
                                  :label="`${eaf_value}`"/>
                      <div v-if="entity[eaf_value].type === 'array'">
                        <v-checkbox v-for="(entity_itms_val2, entity_itms_key2) in entity[eaf_value].allItems"
                                    v-model="computedObjectInput[eaf_value]"
                                    :label="entity_itms_val2"
                                    :value="entity_itms_val2"
                                    v-bind:key="entity_itms_key2" />
                      </div>
                      <div v-if="entity[eaf_value].type === 'file'">
                        <v-file-input
                          ref="createFormUploadFile"
                          @change="changedFileUploadOnEditedItem($event, entity[eaf_value].dbKey)"
                          :rules="entity[eaf_value].validationRules"
                          :placeholder="eaf_value"
                          accept="image/png, image/jpeg"
                          prepend-icon=""
                        ></v-file-input>
                      </div>
                    </v-col>
                  </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-row
          class="kira-additional-header"
          v-if="!!$route.name.match('versions')"
        >
          <v-col
            class="kira-row-pointer ml-4"
            cols="4"
            @click="sendSortingRequest"
          >{{headers[0].text}}
          <v-icon small>{{computedSortingArrowDirection}}</v-icon>
          </v-col>
          <v-col>{{headers[1].text}}</v-col>
        </v-row>
        <v-divider v-if="!!$route.name.match('versions')"/>
      </template>
      <template v-slot:item.roles="{ item }">
        <div class="permissions">
          <div>
            <v-icon v-if="itemContains(item.roles, 'ROLE_SUPER_ADMIN')" color="success">mdi-checkbox-marked-circle</v-icon>
            <v-icon v-else color="red">mdi-close-circle</v-icon> Root
          </div>
          <div>
            <v-icon v-if="itemContains(item.roles, 'ROLE_ADMIN') || itemContains(item.roles, 'ROLE_SUPER_ADMIN')" color="success">mdi-checkbox-marked-circle</v-icon>
            <v-icon v-else color="red">mdi-close-circle</v-icon> Admin
          </div>
        </div>
      </template>
      <template v-slot:item.customerMemberships="{ item }">
        <div class="customerMemberships my-3">
          <!-- New structure: array of foAccountIds -->
          <div
            v-if="item.foAccountIds && item.foAccountIds.length"
          >
            <div
              v-for="(accountId, index) in item.foAccountIds"
              :key="index"
              class="d-flex align-center mb-1"
            >
              <span class="mr-3">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.locked === true"
                      color="red"
                      v-on="on"
                    >
                      mdi-lock-outline
                    </v-icon>
                  </template>
                  <span>
                    User is LOCKED for AccountID: {{ accountId }}
                  </span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.locked === false"
                      color="success"
                      v-on="on"
                    >
                      mdi-lock-open-outline
                    </v-icon>
                  </template>
                  <span>
                    User is UNLOCKED for AccountID: {{ accountId }}
                  </span>
                </v-tooltip>
              </span>
              <span>
                <b><span>AccountID: </span></b>
                {{ accountId }}
              </span>
            </div>
          </div>
          <!-- Fallback: old structure with single foAccountId -->
          <div v-else-if="item.foAccountId">
            <div class="d-flex align-center mb-1">
              <span class="mr-3">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.locked === true"
                      color="red"
                      v-on="on"
                    >
                      mdi-lock-outline
                    </v-icon>
                  </template>
                  <span>
                    User is LOCKED for AccountID: {{ item.foAccountId }}
                  </span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="item.locked === false"
                      color="success"
                      v-on="on"
                    >
                      mdi-lock-open-unlock
                    </v-icon>
                  </template>
                  <span>
                    User is UNLOCKED for AccountID: {{ item.foAccountId }}
                  </span>
                </v-tooltip>
              </span>
              <span>
                <b><span>AccountID: </span></b>
                {{ item.foAccountId }}
              </span>
            </div>
          </div>
          <!-- No data available -->
          <div v-else>
            -
          </div>
        </div>
      </template>
      <template v-slot:item.customer="{ item }">
        <div v-if="item.customer" class="customer">
          {{ item.customer.id }}
        </div>
      </template>
      <template v-slot:item.app="{ item }">
        <div class="appId">
          {{ item.app.id }}
        </div>
      </template>
      <template v-slot:item.active="{ item }">
        <div class="actions">
          <v-icon v-if="item.active" color="success">mdi-checkbox-marked-circle</v-icon>
          <v-icon v-else color="red">mdi-close-circle</v-icon>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="actions">
          <router-link
            v-if="addLinkToDetails"
            :to="{name: `${detailsRouterName}`, params: {id: item.id}}">
            <v-icon
              class="mr-2">
              search
            </v-icon>
          </router-link>
          <v-icon
            v-if="!notShowEditAction && isEditFieldShouldSetOnlyPassword()"
            class="mr-2 mdi mdi-key-variant"
            @click="editItem(item)"/>
          <v-icon
            v-if="!notShowEditAction && !isEditFieldShouldSetOnlyPassword()"
            class="mr-2 edit"
            @click="editItem(item)"/>
          <v-icon
            v-if="!notShowDeleteAction"
            class="mr-2 delete"
            @click="deleteObject(item)"/>
        </div>
      </template>
      <template v-slot:no-data>
        <div class="ma-2">No data to display</div>
        <v-btn color="primary" class="mb-2" @click="getObjects">Reset</v-btn>
      </template>
    </v-data-table>

    <v-dialog max-width="400" v-model="confirmationDialog">
      <v-card>
        <v-card-title class="headline">Delete</v-card-title>

        <v-card-text>
          You are removing <b>{{ editedItem.name || editedItem.email }}</b>.<br>
          Please confirm.
          <v-alert
            v-if="editedItem['@type'] === 'App'"
            type="warning"
            elevation="2"
            class="mt-5"
          >
            Deleting App removes all related licenses. Do you really want to do this?
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            @click="confirmationDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn color="success" @click="deleteObject(editedItem, true)">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Pagination
      v-if="$route.name.match('versions')"
      :paginationLength="calculatePaginationLength"
      class="mt-2"
      @getVersionsPerPage="getVersionsPerPage"
    />
  </div>
</template>

<script>
import * as dayjs from 'dayjs';
import TypeException from '../../exceptions/TypeException';
import Pagination from '../Pagination.vue';
import ImageComponent from '../ImageComponent.vue';
import store from '../../store';

export default {
  name: 'EntityList',
  components: {
    Pagination,
    ImageComponent,
  },
  props: {
    endpoint: String,
    actionEndpoint: String,
    filters: String,
    entity: Object,
    editAllowedFields: Array,
    notDisplayedFields: Array,
    removeFromPayload: Array,
    defaultValues: Object,
    addLinkToDetails: Boolean,
    notShowEditAction: Boolean,
    notShowDeleteAction: Boolean,
    detailsRouterName: String,
    title: String,
    showNewItemBtn: {
      type: Boolean,
      default: true,
    },
    enableSearch: {
      type: Boolean,
      default: false,
    },
    searchFields: {
      type: Array,
      default: () => [{ text: 'Email', value: 'email' }],
    },
  },

  data() {
    return {
      isValidCreateForm: false,
      isValidEditForm: false,
      dataObjectFields: [],
      objectIsEdit: undefined,
      objects: [],
      objectsTotalItems: 1,
      currentPageNumber: 1,
      itemsPerPage: 10,
      sortingOrder: true,
      filterParams: String,
      newObject: false,
      objectInput: {},
      dialog: false,
      confirmationDialog: false,
      headers: [],
      editedIndex: -1,
      itemBeforeEdit: undefined,
      editedItem: {},
      editedItemUploadFiles: [],
      tmpPermissionsArr: [],
      showPassword: false,
      paginationOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      loading: false,
      filterField: null,
      filterValue: '',
      appliedFilter: {
        field: '',
        value: '',
      },
    };
  },

  computed: {
    isFilterApplied() {
      return this.appliedFilter.value !== '';
    },
    store() {
      return store;
    },
    calculatePaginationLength() {
      return Math.ceil(this.objectsTotalItems / 10);
    },
    objectsArr() {
      this.objects.forEach((el) => {
        const element = el;
        element.timestamp = dayjs(el.timestamp).format('DD/MMM/YYYY HH:mm:ss');
      });
      return this.objects;
    },
    computedTitle() {
      return this.title;
    },
    dataObjectFieldsToDisplayArr() {
      return this.prepareDataToDisplay(this.dataObjectFields);
    },
    computedDefaultValues() {
      return this.defaultValues;
    },
    computedObjectInput() {
      return this.objectInput;
    },
    computedSortingArrowDirection() {
      return this.sortingOrder ? 'mdi-arrow-up' : 'mdi-arrow-down';
    },
    getAvailableAppCodes() {
      return store.state.availableAppCodes;
    },
  },
  methods: {
    prepareDataToDisplay(object) {
      const newArr = [];
      object.forEach((el) => {
        if (!this.notDisplayedFields.includes(el)) {
          newArr.push(el);
        }
      });

      return newArr;
    },
    prepareTableHeaders() {
      const SORTABLE_TYPES = ['string', 'int'];
      this.headers = [];

      this.dataObjectFieldsToDisplayArr.forEach((el) => {
        const field = this.entity[el];
        this.headers.push({
          text: field.displayName,
          value: field.dbKey,
          sortable: SORTABLE_TYPES.includes(field.type),
        });
      });

      this.headers.push({ text: 'Actions', value: 'action', sortable: false });
    },
    async setDefaultValues() {
      this.objectInput = { ...this.entity.mock };
      Object.keys(this.computedDefaultValues).forEach((el) => {
        const defaultVal = this.computedDefaultValues[el];
        let parsedVal;
        switch (this.entity[el].type) {
          case 'int':
            parsedVal = parseInt(defaultVal, 10);
            break;
          case 'string':
            parsedVal = defaultVal.toString();
            break;
          case 'array':
            if (typeof defaultVal !== 'object') {
              parsedVal = JSON.parse(defaultVal);
            }
            break;
          default:
            throw new TypeException('EntityList: Type error while setDefaultValues(). Not handled request field type!');
        }
        this.objectInput[el] = parsedVal;
      });

      if (this.$refs.createFormUploadFile && Array.isArray(this.$refs.createFormUploadFile) && this.$refs.createFormUploadFile.length > 0) {
        await this.$refs.createFormUploadFile[0].reset();
      }
      if (this.$refs.editFormUploadFile && Array.isArray(this.$refs.editFormUploadFile) && this.$refs.editFormUploadFile.length > 0) {
        await this.$refs.editFormUploadFile[0].reset();
      }
      this.editedItemUploadFiles = [];
    },
    setDataObjectFields() {
      this.dataObjectFields = Object.keys(this.entity.mock);
    },
    async getObjectsBaseOnTotalItems() {
      this.loading = true;
      const querySeparator = (this.filters === '') ? '?' : '&';
      const { data } = await this.$http.get(`/${this.endpoint}${this.filters}${querySeparator}page=${this.currentPageNumber}&itemsPerPage=${this.itemsPerPage}`, {
        headers: {
          Accept: 'application/ld+json',
        },
      });
      await this.setObjectsData(data);
      this.loading = false;
    },
    async getObjects() {
      this.loading = true;
      let querySeparator = (this.filters === '') ? '?' : '&';

      let filterParams = '';
      if (this.enableSearch && this.appliedFilter.value !== '') {
        filterParams = `${querySeparator}${this.appliedFilter.field}=${encodeURIComponent(this.appliedFilter.value)}`;
        querySeparator = '&';
      }

      let sortParams = '';
      const { sortBy, sortDesc } = this.paginationOptions;
      if (sortBy && sortBy.length > 0) {
        sortParams = `${querySeparator}order[${encodeURIComponent(sortBy[0])}]=${sortDesc[0] ? 'desc' : 'asc'}`;
        querySeparator = '&';
      }

      const { data } = await this.$http.get(
        `/${this.endpoint}${this.filters}${filterParams}${sortParams}${querySeparator}page=${this.currentPageNumber}&itemsPerPage=${this.itemsPerPage}`,
        {
          headers: {
            Accept: 'application/ld+json',
          },
        },
      );
      this.objectsTotalItems = data['hydra:totalItems'];
      await this.setObjectsData(data);
      this.loading = false;
    },
    changedFileUploadOnEditedItem(file, key) {
      this.editedItemUploadFiles.push({ key, file });
    },
    getRouteParamsId() {
      return this.$route.params.id;
    },
    async createObject() {
      if (this.editedItemUploadFiles.length > 0) {
        await this.uploadFiles((fileObjKey, response) => {
          this.objectInput[fileObjKey] = `/api/media_objects/${response.data.id}`;
        });
      }

      delete this.computedObjectInput.id;
      if (Array.isArray(this.removeFromPayload) && this.removeFromPayload.length) {
        this.removeFromPayload.forEach((item) => {
          delete this.computedObjectInput[item];
        });
      }

      const endpoint = (typeof this.actionEndpoint !== 'undefined') ? this.actionEndpoint : this.endpoint;
      await this.$http.post(`/${endpoint}`, this.computedObjectInput);
      await this.getObjects();
      await this.setDefaultValues();
      this.newObject = false;

      if (this.editedItemUploadFiles.length > 0) {
        this.editedItemUploadFiles = [];
      }
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.itemBeforeEdit = Object.assign({}, item);
      if (this.endpoint === 'api/users') {
        this.editedItem.password = '';
        this.itemBeforeEdit.password = '';
      }
      if (this.endpoint === 'api/end_customers') {
        this.objectInput.password = '';
        this.editedItem.password = '';
        this.itemBeforeEdit.password = '';
      }
      this.dialog = true;
      this.objectIsEdit = true;
    },

    async updateObject() {
      if (this.editedItemUploadFiles.length > 0) {
        await this.uploadFiles((fileObjKey, response) => {
          this.editedItem[fileObjKey] = `/api/media_objects/${response.data.id}`;
        });
      }
      this.editedItem.password = this.objectInput.password;

      if (typeof this.editedItem.bccNotificationMail === 'string' && this.editedItem.bccNotificationMail !== '') { this.editedItem.bccNotificationMail = this.editedItem.bccNotificationMail.split(',').map(email => email.trim()); }

      if (this.editedItem.bccNotificationMail === '') {
        this.editedItem.bccNotificationMail = null;
      }

      if (this.editedItem.notificationMail === '') {
        this.editedItem.notificationMail = null;
      }

      if (this.editedItem.mailFooterNote === '') {
        this.editedItem.mailFooterNote = null;
      }

      const payload = { ...this.editedItem };
      delete payload.id;
      const payloadKeys = Object.keys(payload);
      for (let i = 0; i < payloadKeys.length; i++) {
        if (payload[payloadKeys[i]] === this.itemBeforeEdit[payloadKeys[i]]) {
          delete payload[payloadKeys[i]];
        }
      }

      const endpoint = (typeof this.actionEndpoint !== 'undefined') ? this.actionEndpoint : this.endpoint;
      await this.$http.patch(`/${endpoint}/${this.editedItem.id}`, payload, {
        headers: {
          'Content-Type': 'application/merge-patch+json',
        },
      });
      await this.getObjects();
      this.objectIsEdit = false;
    },
    async deleteObject(object, confirmed = false) {
      this.editedItem = object;
      if (!confirmed) {
        this.confirmationDialog = true;
        return;
      }

      const endpoint = (typeof this.actionEndpoint !== 'undefined') ? this.actionEndpoint : this.endpoint;
      const { id } = object;
      await this.$http.delete(`/${endpoint}/${id}`);
      await this.getObjects();
      this.editedItem = {};
      this.confirmationDialog = false;
    },
    itemContains(item, element) {
      return item.indexOf(element) > -1;
    },
    getAccountIdFromItem(item) {
      if (!item) {
        return '';
      }

      if (item.accountId) {
        return item.accountId;
      }

      if (item.foAccountId) {
        return item.foAccountId;
      }

      return '';
    },
    getLockedStatusFromItem(item) {
      if (!item || typeof item.locked !== 'boolean') {
        return undefined;
      }

      return item.locked;
    },
    canEdit(key) {
      return this.editAllowedFields.includes(key);
    },
    canDisplay(key) {
      return !this.notDisplayedFields.includes(key);
    },
    close() {
      this.dialog = false;
      this.objectIsEdit = false;
    },
    async save() {
      if (this.objectIsEdit) {
        await this.$refs.editForm.validate();
        if (this.isValidEditForm) {
          try {
            await this.updateObject();
            this.$store.commit('setPopupAlert', {
              message: 'Object updated successfully!',
              color: 'success',
            });
          } catch (error) {
            let title;
            let message;
            if (error.response?.data?.violations?.length > 0) {
              title = 'Validation Error';
              message = error.response.data.violations.map(v => `${v.propertyPath}: ${v.message}`).join('\n');
            } else {
              title = 'Error';
              message = error.response?.data?.detail || error.response?.data?.['hydra:description'] || 'Error updating object. Please try again.';
            }
            this.$store.commit('setPopupAlert', {
              title,
              message,
              color: 'error',
            });
          }
          this.close();
        }
      } else {
        await this.$refs.createForm.validate();
        if (this.isValidCreateForm) {
          try {
            await this.createObject();
            this.$store.commit('setPopupAlert', {
              message: 'Object created successfully!',
              color: 'success',
            });
          } catch (error) {
            let message;
            let title;
            if (error.response?.data?.violations?.length > 0) {
              title = 'Validation Error';
              message = error.response.data.violations.map(v => `${v.propertyPath}: ${v.message}`).join('\n');
            } else {
              title = 'Error';
              message = error.response?.data?.detail || error.response?.data?.['hydra:description'] || 'Error creating object. Please try again.';
            }
            this.$store.commit('setPopupAlert', {
              title,
              message,
              color: 'error',
            });
          }
          this.close();
        }
      }
    },
    async getVersionsPerPage(page) {
      this.currentPageNumber = page;
      const { data } = await this.$http.get(`/api/versions${this.getFilterParams()}&page=${this.currentPageNumber}`, {
        headers: {
          Accept: 'application/ld+json',
        },
      });
      this.setObjectsData(data);
    },
    setObjectsData(data) {
      this.objects = data['hydra:member'];
      this.objectsTotalItems = data['hydra:totalItems'];
    },
    async sendSortingRequest() {
      this.sortingOrder = !this.sortingOrder;
      const { data } = await this.$http.get(`/api/versions${this.getFilterParams()}&page=${this.currentPageNumber}`, {
        headers: {
          Accept: 'application/ld+json',
        },
      });
      this.setObjectsData(data);
    },
    getFilterParams() {
      return this.sortingOrder ? '?order[name]=desc' : '?order[name]=asc';
    },
    uploadFiles(callback) {
      return new Promise((resolve) => {
        const promises = [];

        this.editedItemUploadFiles.forEach((fileObj) => {
          const formData = new FormData();
          formData.append('file', fileObj.file);

          promises.push(
            this.$http.post('api/media_objects', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }).then((res) => {
              callback(fileObj.key, res);
            }),
          );
        });

        Promise.all(promises).then(() => {
          this.editedItemUploadFiles = [];
          resolve();
        });
      });
    },
    isEditFieldShouldSetOnlyPassword() {
      return this.$route.name.match('customerdetailsendcustomer');
    },
    handlePaginationChange(options) {
      this.currentPageNumber = options.page;
      this.itemsPerPage = options.itemsPerPage;
      this.getObjects();
    },
    applyFilter() {
      if (!this.enableSearch || !this.filterField) return;
      this.appliedFilter = {
        field: this.filterField,
        value: this.filterValue.trim(),
      };
      this.currentPageNumber = 1;
      this.paginationOptions.page = 1;
      this.getObjects();
    },
    clearFilter() {
      this.filterValue = '';
      this.appliedFilter = {
        field: '',
        value: '',
      };
      this.paginationOptions.sortBy = [];
      this.paginationOptions.sortDesc = [];
      this.currentPageNumber = 1;
      this.paginationOptions.page = 1;
      this.getObjects();
    },
  },
  async created() {
    this.appliedFilter = {
      field: '',
      value: '',
    };

    if (this.enableSearch && this.searchFields.length > 0) {
      this.filterField = this.searchFields[0].value;
    }

    await this.setDefaultValues();
    await this.setDataObjectFields();
    await this.getObjects();
    await this.prepareTableHeaders();
  },
};
</script>

<style scoped>
::v-deep .kira-row-pointer {
  cursor: pointer;
}
.kira-additional-header {
  color: rgba(0, 0, 0, 0.6);
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: bold;
}

::v-deep .v-data-table {
  table-layout: fixed;
  width: 100%;
  overflow-x: hidden !important;
}

::v-deep .v-data-table__wrapper {
  overflow-x: hidden !important;
  width: 100%;
}

::v-deep .v-data-table td,
::v-deep .v-data-table th {
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  max-width: 100%;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

::v-deep .v-data-table td *,
::v-deep .v-data-table th * {
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  max-width: 100%;
  overflow: hidden !important;
}

::v-deep .v-data-footer {
  width: 100%;
  overflow-x: hidden !important;
}

div {
  max-width: 100%;
  overflow-x: hidden !important;
}

/* Styles for the filter container */
.filter-container {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background-color: #fafafa;
}

.filter-field-select {
  min-width: 150px;
  max-width: 200px;
}

</style>
